import { useEditor } from "@grapesjs/react";
import {
  BootstrapSizes,
  Box,
  Button,
  ButtonColors,
  Icon,
  LightTable,
  Modal,
  TalentechIcons,
  TalentechSizes,
} from "@talentech/components";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { ProjectData } from "grapesjs";
import { CustomCommands } from "@/shared/utils";
import { galleryTemplates } from "../utils/galleryTemplates";
import { fillPageValues, PageValues } from "../utils/pageValues";

const SelectTemplate = ({ pageValues }: { pageValues: PageValues }) => {
  const editor = useEditor();
  const [showModal, setShowModal] = useState(false);
  const [data, setData] = useState<ProjectData | null>(null);

  const onLoadTemplate = (page: string, callback?: () => void) => {
    fetch(`/templates/${page}.json`)
      .then((res) => res.text())
      .then((text) => {
        editor.loadProjectData(JSON.parse(fillPageValues(text, pageValues)));
      })
      .then(() => {
        callback?.();
      })
      .catch((error) => {
        console.error(`Failed to load template ${page}:`, error);
        toast.error("Failed to load the template");
      });
  };

  useEffect(() => {
    editor.Commands.add(CustomCommands.MODAL_SELECT_TEMPLATES_OPEN, () => {
      setShowModal(true);
    });

    editor.Commands.add(CustomCommands.MODAL_SELECT_TEMPLATES_CLOSE, () => {
      setShowModal(false);
    });
  }, []);

  useEffect(() => {
    showModal && setData(editor.getProjectData());
  }, [showModal]);

  const onCancel = () => {
    data && editor.loadProjectData(data);
    editor.runCommand(CustomCommands.MODAL_SELECT_TEMPLATES_CLOSE);
  };

  return (
    <>
      <Modal
        title="Choose template"
        showModal={showModal}
        onClose={onCancel}
        buttons={[
          <Button onClick={onCancel} label="Cancel" outline key={"cancel"} />,
        ]}
      >
        <LightTable
          data={galleryTemplates}
          columns={[
            {
              label: "Template",
              accessor: "template",
              Component(row) {
                return (
                  <Box flex className="justify-content-between">
                    <Box flex className="align-items-center">
                      <Icon
                        iconSize={TalentechSizes.SMALL}
                        className="border border-1 border-secondary p-2 rounded-1"
                        icon={
                          TalentechIcons.LIGHT_01_INTERFACE_ESSENTIALS_EDIT_PENCIL
                        }
                      />
                      <Box className="ms-2">
                        <p className="caption fw-bold">{row.template}</p>
                        <p className="small text-muted">(non-editable)</p>
                      </Box>
                    </Box>
                    <Box>
                      <Button
                        label={"preview"}
                        color={ButtonColors.PRIMARY}
                        outline
                        onClick={() => onLoadTemplate(row.id)}
                        size={BootstrapSizes.SMALL}
                        className="me-2"
                      />
                      <Button
                        label={"open"}
                        color={ButtonColors.PRIMARY}
                        onClick={() => {
                          onLoadTemplate(row.id, () => {
                            editor.runCommand(
                              CustomCommands.MODAL_SELECT_TEMPLATES_CLOSE
                            );
                          });
                        }}
                        size={BootstrapSizes.SMALL}
                      />
                    </Box>
                  </Box>
                );
              },
            },
          ]}
        />
      </Modal>
    </>
  );
};

export default SelectTemplate;
